/* Keep real VIP gift lines attached to their seat variants on every storefront page. */
(function () {
  'use strict';
  let locked = false;
  let pending = false;
  let notifying = false;
  let timer;
  const root = window.Shopify.routes.root;

  function schedule() {
    if (notifying) return;
    if (locked) {
      pending = true;
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(reconcile, 120);
  }

  async function reconcile() {
    if (locked) return;
    locked = true;
    pending = false;
    try {
      const response = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to read cart');
      const cart = await response.json();
      const seatQuantities = new Map();
      const gifts = new Map();
      cart.items.forEach(function (item) {
        const parent = item.properties && item.properties._vip_gift_for;
        if (parent) {
          const id = String(parent);
          if (!gifts.has(id)) gifts.set(id, []);
          gifts.get(id).push(item);
        } else {
          const id = String(item.variant_id);
          seatQuantities.set(id, (seatQuantities.get(id) || 0) + item.quantity);
        }
      });
      const updates = {};
      gifts.forEach(function (items, parent) {
        // Aggregate seats with different vehicle properties, but never duplicate their gift allowance.
        items.forEach(function (item, index) {
          const quantity = index === 0 ? (seatQuantities.get(parent) || 0) : 0;
          if (item.quantity !== quantity) updates[item.key] = quantity;
        });
      });
      if (!Object.keys(updates).length) return;
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true, detail: { sections: sections },
      }));
      const result = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname }),
      });
      if (!result.ok) throw new Error('Unable to synchronize gift quantities');
      const updatedCart = await result.json();
      if (updatedCart.errors) throw new Error(updatedCart.errors);
      notifying = true;
      try {
        if (window.MinimogEvents && window.MinimogTheme && sections.length) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: updatedCart });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
        }
      } finally {
        notifying = false;
      }
    } catch (error) {
      console.error('[VIP gift cart]', error);
    } finally {
      locked = false;
      if (pending) schedule();
    }
  }

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('product-ajax:added', schedule);
  if (window.MinimogEvents && window.MinimogTheme) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, schedule);
  }
  schedule();
})();
